mutation SetPreferredRole($userRoleId: ID!) {
  setPreferredRole(userRoleId: $userRoleId) {
    id
    description
    tenantId
    tenantName
    isPreferred
  }
}